(function ($, Drupal) {

  // title, text and so height matching inside cards
  Drupal.behaviors.initEcommerceVideo = {
    attach: function (context, settings) {

      $('.js_ecommerceVideo', context).once('initEcommerceVideo').each(function () {

        const $this = $(this),
              $btnOpen = $this.find('.ecommerce__video_btn'),
              $btnClose = $this.find('.modal__inner_btn'),
              $modal = $this.find('.modal');

        function setupModal() {

          const $wrap = $modal.find('.modal__inner_video'),
                $iframe = $wrap.find('iframe');

          function calculateRatio() {

            const $width = $iframe.width(),
                  $height = $iframe.height(),
                  $paddingFactor = ($height / $width) * 100;

            $wrap.css('padding-top', `${$paddingFactor}%`).addClass('videowrap');

            $modal.appendTo('body');
          }

          $iframe.ready(calculateRatio());
        }

        setupModal();

        $btnOpen.on('click', function () {
          $modal.addClass('active');
        });

        $btnOpen.on('click', function () {
          $modal.addClass('active');
        });

        $btnClose.on('click', function () {
          $modal.removeClass('active');
        });

      });

    }
  };

})(jQuery, Drupal);
